import React, { useEffect } from 'react';
import { Button, Form, Modal, Space, DatePicker } from 'antd';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { IModal } from 'common/models/model.interface';
import { DATE_MMMM_D_YYYY_H_MMA } from 'common/constans/date.constants';
import dayjs from 'dayjs';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { ReactComponent as PrintIcon } from 'assets/icons/print.svg';
import '../daily-activity-reports.scss';
import EiqDatePicker from 'common/components/date-picker/eiq-date-picker';

const PrintDailyActivityReportFilterModal = ({ title, isEdit, initData, isOpen, onClose }: IModal<any, any>) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (form && isOpen) {
      form.setFieldsValue(initData);
    }
  }, [isOpen, form, initData]);

  const hideModal = (...rest: any) => {
    form.resetFields();
    if (onClose) {
      onClose(...rest);
    }
  };

  const onFinish = async (values: any) => {
    const from = dayjs(values.from).utc().valueOf();
    const to = dayjs(values.to).utc().valueOf();

    hideModal(true, from, to);
  };

  return (
    <Modal
      centered
      title={title}
      width={550}
      open={isOpen}
      wrapClassName="custom-modal daily-activity-report-modal"
      closable={true}
      onCancel={() => hideModal(false)}>
      <FormWrapper form={form} initialValues={initData} onFinish={onFinish} layout="vertical">
        <>
          <Space className="full-width" size={13}>
            <Form.Item name="from" label="From" rules={formRules.from}>
              <EiqDatePicker
                format={DATE_MMMM_D_YYYY_H_MMA}
                showTime={{
                  format: 'hh:mm A',
                  use12Hours: true,
                  defaultValue: dayjs('24:00', 'HH:mm'),
                }}
                placeholder="Date & Time from"
                allowClear={false}
              />
            </Form.Item>
          </Space>
          <Space className="full-width" size={13}>
            <Form.Item name="to" label="To" rules={formRules.to}>
              <EiqDatePicker
                format={DATE_MMMM_D_YYYY_H_MMA}
                showTime={{
                  format: 'hh:mm A',
                  use12Hours: true,
                  defaultValue: dayjs('24:00', 'HH:mm'),
                }}
                placeholder="Date & Time to"
                allowClear={false}
              />
            </Form.Item>
          </Space>
        </>
        <Space className="footer full-width">
          <div className="activity-report-print-filter">
            <div className="label">
              {initData.printType === 'Export' ? 'Exporting' : 'Printing'} time may vary based on the duration of the selected date range.
            </div>
            <Button htmlType="submit" icon={initData.printType === 'Export' ? <CloudDownloadOutlined /> : <PrintIcon />}>
              {initData.printType}
            </Button>
          </div>
        </Space>
      </FormWrapper>
    </Modal>
  );
};

export default React.memo(PrintDailyActivityReportFilterModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});

const formRules = {
  from: [{ required: true, message: 'Date & Time from is required!' }],
  to: [{ required: true, message: 'Date & Time to is required!' }],
};
